import { render, staticRenderFns } from "./clearCompletedTodos.vue?vue&type=template&id=9fe98b8e&"
import script from "./clearCompletedTodos.vue?vue&type=script&lang=js&"
export * from "./clearCompletedTodos.vue?vue&type=script&lang=js&"
import style0 from "./clearCompletedTodos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports